import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { changeBody } from '../../../modules/conveyor/conveyorWriteSlice';

import ProfileSelectButton from './ProfileSelectButton';

const ProfileFormBlock = styled.div`
    margin-left: 2rem;
`;

const Img = styled.div`
    width: 50%;
    max-width: 600px;
    min-width: 400px;
    img {
        width: 100%;
    }
`;

const ProfileForm = ({ profile: prevProfile }) => {
    const dispatch = useDispatch();

    // const [profileImageNumber, setProfileImageNumber] = useState(profile?.profileImageNumber ? profile?.profileImageNumber : '0001');

    const [profile, setProfile] = useState(
        prevProfile || {
            imgNumber: '0001',
        },
    );

    /* 리덕스에 쓰기 */
    useEffect(() => {
        dispatch(
            changeBody({
                key: 'profile',
                value: profile,
            }),
        );
    }, [dispatch, profile]);

    return (
        <ProfileFormBlock>
            <ProfileSelectButton setProfile={setProfile} />
            <Img>
                <img
                    src={require(`../../../images/profile_${profile.imgNumber}_without_dimension.png`)}
                    alt={`profile_${profile.imgNumber}_without_dimension.png`}
                />
            </Img>
        </ProfileFormBlock>
    );
};

export default ProfileForm;
